import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CircularProgress, SxProps, Theme, Stack, ButtonBase } from '@mui/material';

import { intl } from '@ocx-app/lib/translation/TranslationProvider';
import { SizingMultiplier, Typography } from '@ocx/ui';

import { locationSelectorMessages } from './location-selector.messages';
import { LocalOffersLocationState } from '../local-offers.types';

export type LocationSelectorProps = {
  onClick?: () => void;
  locationState: LocalOffersLocationState;
  customLocationName?: string;
  sx?: SxProps<Theme>;
};

const ICON_SIZE = 20;
const CIRCULAR_PROGRESS_SIZE = 16;
const VERTICAL_SPACING = 0.75;
const LOCATION_BUTTON_HEIGHT = 40;

export const LocationSelector = ({ onClick, locationState, customLocationName, sx }: LocationSelectorProps) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        height: LOCATION_BUTTON_HEIGHT,
        borderRadius: (theme) => theme.shape.borderRadius,
        py: VERTICAL_SPACING,
        px: SizingMultiplier.md,
        whiteSpace: 'nowrap',
        backgroundColor: (theme) => theme.palette.action.selected,
        ...sx,
      }}>
      <Stack direction="row" alignItems="center" width="100%">
        {locationState === 'fetching' && (
          <>
            <CircularProgress size={CIRCULAR_PROGRESS_SIZE} color="inherit" sx={{ marginRight: SizingMultiplier.xs }} />
            <Typography variant="body2">
              {intl.formatMessage(locationSelectorMessages['locationSelector:fetchingYourLocationLabel'])}
            </Typography>
          </>
        )}

        {locationState !== 'fetching' && (
          <>
            <LocationOnOutlinedIcon
              sx={{
                marginRight: 0.25,
                width: ICON_SIZE,
                height: ICON_SIZE,
                color: (theme) => theme.palette.text.disabled,
              }}
            />
            <Typography variant="body2" noWrap sx={{ flex: 1, textAlign: 'left' }}>
              {locationState === 'nearby' &&
                intl.formatMessage(locationSelectorMessages['locationSelector:showingNearbyOffersLabel'])}
              {locationState === 'custom' && customLocationName}
              {locationState === 'all' &&
                intl.formatMessage(locationSelectorMessages['locationSelector:showingAllOffersLabel'])}
            </Typography>
            <ExpandMoreIcon
              sx={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                color: (theme) => theme.palette.text.disabled,
              }}
            />
          </>
        )}
      </Stack>
    </ButtonBase>
  );
};
